














































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import InvestorGoalMovementsViewModel
  from '@/vue-app/view-models/components/goals-dashboard/linked-goals/investor-goal-movements-dialog-view-model';
import InvestorGoalMovements from '@/vue-app/components/goals-dashboard/linked-goals/InvestorGoalMovements.vue';

@Component({
  name: 'InvestorGoalMovementsDialog',
  components: {
    InvestorGoalMovements,
    RangePicker: () => import('@/vue-app/components/RangePicker.vue'),
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class InvestorGoalMovementsDialog extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  view_model = Vue.observable(new InvestorGoalMovementsViewModel(this));

  closeModal() {
    this.synced_is_open = false;
  }

  created() {
    this.view_model.initialize();
  }
}
